import { Paper, styled } from '@mui/material';

export const Wrap = styled(Paper, {
	shouldForwardProp: (prop) => prop !== 'isStudent',
})<{ isStudent?: boolean }>(({ theme, isStudent }) => ({
	background: isStudent ? theme.palette.error.main : '#F7C5C599',
	color: isStudent ? theme.palette.error.contrastText : '#C41C1C',

	padding: '8px',
	borderRadius: '8px',

	position: 'relative',

	[theme.breakpoints.down('sm')]: {
		'& .MuiTypography-root': {
			fontSize: '14px',
		},
	},
}));

export const Mark = styled('img')(({ theme }) => ({
	width: '75px',
	height: '75px',
	position: 'absolute',
	right: '0px',
	top: '0px',
	transform: 'translateY(-50%)',

	[theme.breakpoints.down('sm')]: {
		display: 'none',
	},
}));
